// namespace
export const DOCUMENTS_NAMESPACE = 'documents'

// getters
export const DOCUMENTS_GETTER = 'documents'

// mutations
export const DOCUMENTS_MUTATION_ENTIRE_DOCUMENTS = 'updateEntireDocuments'
export const DOCUMENTS_MUTATION_PHOTOS = 'updatePhotos'

// actions
export const DOCUMENTS_ACTION_GET_DOCUMENTS = 'fetchDocuments'
export const DOCUMENTS_ACTION_UPLOAD_FILE = 'uploadFile'
export const DOCUMENTS_ACTION_DELETE_FILE = 'deleteFile'

// types
export const DOCUMENTS_TYPE_PHOTO = 'photo'
export const DOCUMENTS_TYPE_GENERAL_DOCUMENT = 'document'
export const DOCUMENTS_TYPE_VIDEO = 'video'



// WEBPACK FOOTER //
// ./src/store/modules/documents-types.js